import { Link } from "react-router-dom";
import Logo from "./Logo";

const Error = ({ code, message }) => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-canvas px-6 text-slate-800">
      <Logo variant="dark" to="/admin/accounts" />
      <h1 className="mt-10 font-display text-8xl font-bold text-slate-900">{code}</h1>
      <p className="mt-4 text-center text-2xl text-slate-600">{message}</p>
      <Link to="/admin/accounts" className="btn-primary mt-10">
        Back to Accounts
      </Link>
    </div>
  );
};

export const BadRequestError = () => <Error code="400" message="Bad Request" />;
export const UnauthorizedError = () => <Error code="401" message="Unauthorized Access" />;
export const NotFoundError = () => <Error code="404" message="Page Not Found" />;

export default Error;
